// Runtime Configuration
// Single source of truth for API and WebSocket URLs.
// Delegates to environment.ts for environment detection.

import { getEnvironmentConfig } from './environment';

const envConfig = getEnvironmentConfig();

export const API_URL = envConfig.apiUrl;
export const WS_URL = envConfig.wsUrl;
